module.exports = __webpack_public_path__ + "img/022-elephant.17d6474e.svg";